import { forwardRef } from 'react'

function textCleanup(l) {
  if (/^\d/.test(l)) l = l.slice(2)
  if (l.includes(';-')) l = l.slice(0, l.indexOf(';'))
  if (l.includes(')')) l = l.slice(0, l.indexOf(')') + 1)
  l = l.replace(';-', '')
  return l
}

const PresentTiles = forwardRef(function PresentTiles({ tiles, activeTileIndex, activeSongIndex, previewLang, onTileSelect, songs }, ref) {
  let lastSongIndex = -1

  return (
    <div className="present-tiles" ref={ref}>
      {tiles.map((tile, index) => {
        const showDivider = tile.songIndex !== lastSongIndex
        lastSongIndex = tile.songIndex

        const lines = previewLang === 'en' ? tile.verse : tile.verse2
        const isActive = activeTileIndex === index

        return (
          <div key={index} style={{ display: 'contents' }}>
            {showDivider && (
              <div className={`present-tiles-divider${tile.songIndex === activeSongIndex ? ' present-tiles-divider--active' : ''}`} data-song-index={tile.songIndex}>
                <span className="fs-6">{tile.song.title}</span>
              </div>
            )}
            <div
              className={`present-tile fs-6 frosted ticks${isActive ? ' present-tile--active ticks--active' : ''}`}
              onClick={() => onTileSelect(index)}
            >
              <div className="present-tile-label">{tile.label}</div>
              {lines && lines.map((line, i) => (
                <div key={i}>{textCleanup(line)}</div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
})

export default PresentTiles
